<style lang="scss">
  .tab-group {
    display: flex;
    flex-direction: row;
    gap: 0;
  }
</style>

<script>
  import TabItem from "./TabItem.svelte";

  export let items = [];
  export let selectedTab = ""; // bind to this, returns id of selected tab.

  export let type = "primary";
  export let size = "large";

  $: tabProps = {
    type,
    size,
  };
</script>

<div class="tab-group">
  {#each items as item}
    <TabItem
      {...item}
      {...tabProps}
      badgeProps={{
        contrast: selectedTab === item.id ? "yellow" : "disabled",
        position: "center",
        inline: true,
      }}
      active={selectedTab === item.id}
      onclick={() => {
        selectedTab = item.id;
      }}
    />
  {/each}
</div>
